/* eslint-disable */
import dicts from './example'
  
export const branchMemberPopularizeCols = [
  {
    title: '文章题目',
    key: 'title',
    tooltip: true,
    minWidth: 240,
  },
  {
    title: '类型',
    slot: 'popularizeType',
    tooltip: true,
    width: 150,
  },
  {
    title: '执笔人',
    key: 'writer',
    width: 140,
  },
  {
    title: '报送时间',
    key: 'submitTime',
    width: 160,
  },
  {
    title: '报送渠道',
    key: 'submitChannel',
    width: 160,
  },
  {
    title: '采用渠道',
    key: 'useChannel',
    width: 160,
  },
  {
    title: '备注',
    key: 'remark',
    width: 300,
    tooltip: true
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchMemberPopularizeForm = {
  attrs: {
    labelWidth: '120px',
    'label-position': 'left',
    // rules: {
    //   popularizeType: [
    //     {
    //       required: true,
    //       message: '请选择类型',
    //       trigger: 'change',
    //     },
    //   ],
    //   title: [{ required: true, message: '请输入文章题目', trigger: 'blur' }],
    //   writer: [{ required: true, message: '请输入执笔人', trigger: 'blur' }],
    //   submitTime: [
    //     {
    //       required: true,
    //       message: '请选择报送时间',
    //       trigger: 'change',
    //     },
    //   ],
    //   submitChannel: [
    //     {
    //       required: true,
    //       message: '请选择报送渠道',
    //       trigger: 'change',
    //     },
    //   ],
    //   useChannel: [
    //     {
    //       required: true,
    //       message: '请选择采用渠道',
    //       trigger: 'change',
    //     },
    //   ],
    // },
  },
  items: [
    {
      label: '文章题目',
      prop: 'title',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '类型',
      prop: 'popularizeType',
      options: dicts.popularizeType(),
    },
    {
      label: '执笔人',
      prop: 'writer',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'datepicker',
      label: '报送时间',
      prop: 'submitTime',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      type: 'cascader',
      label: '报送渠道',
      prop: 'submitChannel',
      options: dicts.submitChannel(),
      props: {
        multiple: true,
      },
    },
    {
      type: 'cascader',
      label: '采用渠道',
      prop: 'useChannel',
      options: dicts.submitChannel(),
      props: {
        multiple: true,
      },
    },
    {
      type: 'textarea',
      label: '备注',
      prop: 'remark',
      maxlength: 5000,
      showWordLimit: true,
      clearable: true,
      rows: 6
    }
  ],
}